import { Body, Controller, Post } from '@nestjs/common';
import {
  ApiForbiddenResponse,
  ApiNotFoundResponse,
  ApiOkResponse,
  ApiOperation,
  ApiTags,
} from '@nestjs/swagger';
import { SendOtpRequest } from '../models/requests/send-otp.request';
import { OtpService } from '../services/otp.service';
import { CheckOtpRequest } from '../models/requests/check-otp.request';
import { AuthenticatedUserResponse } from '@ip6m/server/shared';

@Controller('user-auth/otp')
@ApiTags('login and registration')
export class OtpController {
  constructor(private otpService: OtpService) {}

  /**
   * @throws UserNotFoundException
   */
  @Post('send')
  @ApiOperation({
    operationId: 'sendOtp',
    description: 'Send OTP',
  })
  @ApiOkResponse()
  @ApiNotFoundResponse({
    description: 'Non existent user',
  })
  public async postSend(@Body() { email }: SendOtpRequest): Promise<void> {
    return this.otpService.sendOtp(email);
  }

  /**
   * @throws UserNotFoundException
   * @throws ForbiddenException
   */
  @Post('check')
  @ApiOperation({
    operationId: 'checkOtp',
    description: 'Check OTP',
  })
  @ApiOkResponse({
    type: AuthenticatedUserResponse,
  })
  @ApiForbiddenResponse({
    description: 'Invalid credentials',
  })
  public async postCheck(
    @Body() { email, otp }: CheckOtpRequest
  ): Promise<AuthenticatedUserResponse> {
    return this.otpService.checkOtp(email, otp);
  }
}
